export const INTEGRATION_TYPE = {
  MANUAL_INTEGRATION: 0,
  SALES_PLATFORM: 1,
  PAYMENT_PLATFORM: 2,
  MARKETING_PLATFORM: 3,
  ACCOUNTING_PLATFORM: 4,
  BANKING_API_PLATFORM: 5,
  SALES_OTHERS_PLATFORM: 6,
};
